<template>
  <layout>
    <payment v-if='isLoaded === 1'        :config='config' :origin='origin' :authCode='authCode' :mode='mode' :version='"version"' :params='params' />
    <span    v-else-if='isLoaded === 99'  class='text-red'>{{$t('error')}}</span>
    <span    v-else style="text-align:center;">{{$t('loading...')}}</span>
    <!-- <span style='font-size:0.8rem;'>{{appVersion}}</span> -->
  </layout>
</template>

<script>
import Layout from '@/viewLayout'
import Payment from '@/views/payment/views/desktop'
import RequestHandler from '@/mixins/RequestHandler'

export default {
  name: 'App',
  mixins: [RequestHandler],
  components: { Layout, Payment },
  data () {
    return {
      config: null,
      params: null,
      origin: null,
      authCode: null,
      mode: '1',
      isLoaded: 0
    }
  },
  created () {
    this.loadRequestParams()
  }
}
</script>

<style>
#app {
  font-family: Arial, Avenir, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
